export default function setPasswordForm() {
    return {
        formData: {
            password: '',
            confrimPassword: ''
        },
      
        form: {},
        showSuccessMesage: false,
        successMessage:'',
        message: '',
        errors: {},
        mounted() {

        },
        
        validateForm() {
            this.errors = {};

            if (!this.formData.password) {
                this.errors.password = 'Password is required.';
            } 
            else {
                delete this.errors["password"];
            }

            if (!this.formData.confrimPassword) {
                this.errors.confrimPassword = 'Confrim password is required.';
            } else if (this.formData.confrimPassword != this.formData.password) {
                this.errors.confrimPassword = 'Password and Confrim password not match.';
            }
            else {
                delete this.errors["confrimPassword"];
            }
            return Object.keys(this.errors).length === 0;

        },
        onResetPasswordClick() {
            this.resetPassword = true;
        },
      
        
        submitData() {
            if (this.validateForm()) {
                fetch('/api/login/resetpassword', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: document.getElementById("email").value,
                        password: this.formData.confrimPassword,
                    })
                }).then(response => {
                    return response.json();
                }).then(login => {

                    if (login.isSuccess) {
                        this.showSuccessMesage = login.isSuccess;
                        this.successMessage = "Password Reset Successfully. Please login"
                    }
                    else {
                        this.message = login.message;
                    }

                })
            }
        }
    };
}
